import { combineReducers } from "@reduxjs/toolkit";
import mobileMenuReducer from "./mobileMenuReducer";
import cartReducer from "./cartReducer";

const reducers = combineReducers({
  mobileMenu: mobileMenuReducer,
  cartReducer: cartReducer,
});

export default reducers;
